import { Avatar } from 'antd'
import React from 'react'
import { MdAdd } from 'react-icons/md'

const HeaderBarAdd = (props) => {
    const { title, handleAdd, titleClassName = '', headerBarClassName = '', disabled = false, isShow = true } = props
    return (
        <div className={'header-bar flex justify-between items-center py-2 w-full ' + headerBarClassName}>
            <div className={"header-bar-title " + titleClassName}>{title}</div>
            <div className={!disabled ? "btn-header-add cursor-pointer" : "btn-header-add-disabled"} >
                {!disabled && isShow &&
                    <Avatar
                        shape="square"
                        icon={<MdAdd className='icon-add' />}
                        className="m-1"
                        onClick={handleAdd} />
                }
                {disabled && isShow &&
                    <Avatar
                        shape="square"
                        icon={<MdAdd className='icon-add' />}
                        className="m-1" />
                }
            </div>
        </div>
    )
}

export default HeaderBarAdd